import { faSpinnerThird } from '@awesome.me/kit-24322b77ac/icons/sharp/regular';
import classNames from 'classnames';
import type { JSX, ReactNode } from 'react';

import { Icon } from '../Icon/Icon';

import './Spinner.less';

interface SpinnerProps {
  size: 'small' | 'large';
  extra?: ReactNode;
  icon?: ReactNode;
  centered?: boolean;
  className?: string;
}

export const Spinner = ({ size, extra, icon, centered, className }: SpinnerProps): JSX.Element => {
  return (
    <>
      <div className={classNames('spinner', centered && 'spinner-centered', className)}>
        {size === 'small' ? (icon ?? <Icon icon={faSpinnerThird} spin />) : (icon ?? <Icon style={{ fontSize: 24 }} icon={faSpinnerThird} spin />)}
      </div>
      {extra && <div>{extra}</div>}
    </>
  );
};
